<!--
	TEMPLATE
-->
<template>
<div class="editable-text">
	<div v-if="!isEditView" :class="{'text-italic': value === ''}">{{ label }}</div>

	<div v-if="isEditView">
		<textarea :rows="options.rows" :maxlength="options.limit" @input="$emit('input', $event.target.value)" @change="changedText">{{ value }}</textarea>
		<div v-if="options.limit > 0 && value !== ''" class="editable-text__counter">
			<span v-if="value.length === options.limit">You've reached the limit of {{ options.limit }} letters!</span>
			<span v-else>{{ value.length }}/{{ options.limit }}</span>
		</div>
	</div>
</div>
</template>

<!--
	SCRIPT
-->
<script>
export default {
	props: {
		value: String,
		options: Object,
		isEditView: Boolean
	},
	data: function() {
		return {
			isEmpty: false,
      label: this.value === '' ? 'There is no content here yet!' : this.value
		}
	},
  methods: {
    changedText(s) {
      //console.log('changed',s.target.value);
      this.label = s.target.value == '' ? 'There is no content here yet!' : s.target.value;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/editable-items/EditableText.vue